import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { baseQuery, endpoints } from 'utils/api/endpoints';
import { State } from './types';

export const initialState: State = {
  selectedNotification: null,
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setSelectedNotification: (state, action: PayloadAction<any>) => {
      state.selectedNotification = action.payload;
    },
  },
});

export const api = createApi({
  reducerPath: 'notificationsApi',
  baseQuery,
  tagTypes: ['notifications'],
  endpoints: builder => ({
    getNotifications: builder.query<any, any>({
      query: params => ({
        url: endpoints.NOTIFICATIONS,
        method: 'GET',
        params,
      }),
      providesTags: ['notifications'],
    }),
    getNotificationStats: builder.query<any, any>({
      query: params => ({
        url: endpoints.NOTIFICATIONS_STATS,
        method: 'GET',
        params,
      }),
      providesTags: ['notifications'],
    }),
    markAsRead: builder.mutation<any, any>({
      query: id => ({
        url: `${endpoints.NOTIFICATIONS}/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['notifications'],
    }),
    markAllAsRead: builder.mutation<any, any>({
      query: () => ({
        url: endpoints.NOTIFICATIONS_MARK_ALL_READ,
        method: 'PATCH',
      }),
      invalidatesTags: ['notifications'],
    }),
    deleteNotification: builder.mutation<any, any>({
      query: id => ({
        url: `${endpoints.NOTIFICATIONS}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['notifications'],
    }),
  }),
});

export const { actions: NotificationsAction } = slice;

export const useNotificationsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useGetNotificationsQuery: api.useLazyGetNotificationsQuery,
    useGetNotificationStatsQuery: api.useLazyGetNotificationStatsQuery,
    useMarkAsReadMutation: api.useMarkAsReadMutation,
    useMarkAllAsReadMutation: api.useMarkAllAsReadMutation,
    useDeleteNotificationMutation: api.useDeleteNotificationMutation,
    actions: NotificationsAction,
  };
};
